import { io } from 'socket.io-client';


console.log(
  '[INIT] bigTournamentShortSocket.js'
);


const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  'http://localhost:5000';


const bigTournamentShortSocket =
  io(
    `${SOCKET_URL}/big-tournament-short`,
    {
      autoConnect: false,
      transports: ['websocket'],
    }
  );


const eventQueue = [];

const ANCHOR =
  'bigTournamentShort:lastActiveTableId';


function clearBigTournamentShortAnchor() {
  try {
    localStorage.removeItem(
      ANCHOR
    );

    sessionStorage.removeItem(
      ANCHOR
    );
  } catch (_) {}
}


export function syncBigTournamentShortActiveTable(
  callback
) {
  if (
    !bigTournamentShortSocket.connected
  ) {
    return;
  }


  bigTournamentShortSocket.emit(
    'big_getMyActiveTable',
    (payload) => {
      if (payload?.tableId) {
        try {
          localStorage.setItem(
            ANCHOR,
            String(payload.tableId)
          );
        } catch (_) {}
      } else {
        clearBigTournamentShortAnchor();
      }


      if (
        typeof callback === 'function'
      ) {
        callback(payload || null);
      }
    }
  );
}


bigTournamentShortSocket.on(
  'connect',
  () => {
    console.log(
      '[CLIENT] bigTournamentShortSocket connected'
    );


    while (
      eventQueue.length > 0
    ) {
      const {
        event,
        payload,
      } = eventQueue.shift();

      bigTournamentShortSocket.emit(
        event,
        payload
      );
    }


    let storedId = null;

    try {
      storedId =
        sessionStorage.getItem(
          ANCHOR
        ) ||
        localStorage.getItem(
          ANCHOR
        );
    } catch (_) {}


    const username =
      localStorage.getItem(
        'username'
      ) || '';


    if (
      storedId &&
      username
    ) {
      const tableId =
        Number(storedId);


      if (
        Number.isInteger(tableId) &&
        tableId > 0
      ) {
        bigTournamentShortSocket.emit(
          'joinShortTable',
          {
            shortTableId:
              tableId,

            playerUsername:
              username,
          }
        );


        bigTournamentShortSocket.emit(
          'shortFetchData',
          tableId
        );
      }
    }


    syncBigTournamentShortActiveTable();
  }
);


bigTournamentShortSocket.on(
  'connect_error',
  (error) => {
    console.warn(
      '[BIG SHORT] connect_error:',
      error?.message || error
    );
  }
);


bigTournamentShortSocket.on(
  'disconnect',
  (reason) => {
    console.log(
      '[BIG SHORT] disconnect:',
      reason
    );
  }
);


export function safeBigTournamentShortEmit(
  event,
  payload
) {
  if (
    bigTournamentShortSocket.connected
  ) {
    bigTournamentShortSocket.emit(
      event,
      payload
    );
  } else {
    eventQueue.push({
      event,
      payload,
    });
  }
}


export function ensureBigTournamentShortSocketAuthAndConnect() {
  try {
    const token =
      localStorage.getItem(
        'token'
      ) || '';

    const username =
      localStorage.getItem(
        'username'
      ) || '';


    bigTournamentShortSocket.auth = {
      token,
      username,
    };

  } catch (_) {}


  if (
    !bigTournamentShortSocket.connected &&
    !bigTournamentShortSocket.connecting
  ) {
    bigTournamentShortSocket.connect();
  }
}


export function ensureBigTournamentShortSocket(
  username
) {
  if (!username) {
    return;
  }


  const token =
    localStorage.getItem(
      'token'
    ) || '';


  bigTournamentShortSocket.auth = {
    token,
    username,
  };


  if (
    !bigTournamentShortSocket.connected &&
    !bigTournamentShortSocket.connecting
  ) {
    bigTournamentShortSocket.connect();
  }
}


bigTournamentShortSocket.on(
  'big_tournamentTable',
  ({
    tableId,
  }) => {
    if (!tableId) {
      return;
    }

    try {
      localStorage.setItem(
        ANCHOR,
        String(tableId)
      );
    } catch (_) {}
  }
);


bigTournamentShortSocket.on(
  'short_clearActiveTable',
  clearBigTournamentShortAnchor
);

bigTournamentShortSocket.on(
  'short_tableClosed',
  clearBigTournamentShortAnchor
);

bigTournamentShortSocket.on(
  'short_gameFinished',
  clearBigTournamentShortAnchor
);


export function forgetBigTournamentShortAnchor() {
  clearBigTournamentShortAnchor();
}


export default bigTournamentShortSocket;